export default __webpack_public_path__ + "2472766c3a8f3fa840f119ae73fb98b9.svg";